module.exports = __webpack_public_path__ + "static/media/helper.7cb7fc7a.JPG";